import { ADD_AREA, UPDATE_AREA, GET_AREA, GET_AREA_BY_ID, DELETE_AREA } from '../types';
import { toast } from 'react-toastify';
import axios from '../../axios';

export const getArea = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/area/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_AREA, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error("Failed to get Area. Please try again.", err);
   }
};

export const getAreaById = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/area/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_AREA_BY_ID, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const addArea = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/area/add', data);
      if (res.data.code === 1) {
         dispatch({ type: ADD_AREA, payload: res.data.data });
         setTimeout(() => {
            toast.success('Area added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateArea = (data) => async (dispatch) => {
   try {
      const res = await axios.post(`/area/update`, data);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_AREA, payload: res.data.data });
         setTimeout(() => {
            toast.success('Area updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const deleteArea = (id) => async (dispatch) => {
   try {
      const res = await axios.post(`/area/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_AREA, payload: { id } });
         setTimeout(() => {
            toast.success('Area deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
